// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_ZRUIb9JAFRvF-O5WFoR2iJDNMMYWoYw",
  authDomain: "covoiturage-blois.firebaseapp.com",
  projectId: "covoiturage-blois",
  storageBucket: "covoiturage-blois.firebasestorage.app",
  messagingSenderId: "704875843995",
  appId: "1:704875843995:web:5eb68c367025e7012e913e",
  measurementId: "G-W49LKS1X67",
  // Ajout de l'URL de la base de données Realtime Database
  databaseURL:
    "https://covoiturage-blois-default-rtdb.europe-west1.firebasedatabase.app",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const analytics = getAnalytics(app);
const database = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Export des services pour utilisation dans l'application
export { app, analytics, database, auth, storage };

// Export par défaut de l'app Firebase
export default app;
